<template>
    <div
        id="anchor-news"
        class="blog">
        <div class="custom-header">
            <h1>{{ $t("news.title") }}</h1>
        </div>
        <div class="static-page">
            <section class="card-generic articles">
                <div class="articles-container">
                    <div
                        v-for="(elem, i) in articles"
                        :key="i"
                        class="article is-cursor"
                        @click="goToArticle(elem.link)">
                        <figure :style="getThumbnailStyle(elem.thumbnail)" />

                        <p class="is-text-semi">
                            {{
                                elem.title.length > 50
                                    ? elem.title.substr(0, 50) + "..."
                                    : elem.title
                            }}
                        </p>
                    </div>
                </div>
            </section>
        </div>
        <a
            href="https://medium.com/sandbox-game/partnerships/home"
            target="_blank">
            {{ $t("news.link") }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'News',
    data () {
        return {
            articles: []
        }
    },
    mounted () {
        this.getMediumPosts()
    },
    methods: {
        goToArticle (link) {
            window.open(link, '_blank')
        },
        getMediumPosts () {
            this.axios
                .get(
                    'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/sandbox-game/tagged/partnerships'
                )
                .then(res => {
                    this.articles = res.data.items.slice(0, 4)
                })
                .catch(() => {})
        },
        getThumbnailStyle (url) {
            return `background-image: url(${url})`
        }
    }
}
</script>

<style lang="scss" scoped>
.blog {
  background-color: $gray3;
  padding-bottom: 100px;
  @include breakpoint($device: mobile) {
      padding-bottom: 80px;
  }
}
.static-page {
  padding: 0;
  margin: 0 auto;
  overflow: hidden;
  width: auto;
  min-height: auto;
  max-width: 1380px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 10px;
  @include breakpoint($device: mobile) {
    width: 320px;
  }
}
a {
  font-weight: bold;
  font-size: 18px;
  transition: 200ms;
  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
}
.custom-header {
  max-width: 100%;
  margin-bottom: 30px;
  text-align: center;
  padding-top: 100px;
  @include breakpoint($device: mobile) {
      padding-top: 80px;
  }
  h1 {
    margin: 0;
    font-size: 50px;
    font-weight: Bold;
    text-transform: uppercase;
    @include breakpoint($device: touch) {
        font-size: 25px;
    }
  }
}
.card-generic {
  width: 95%;
  @include breakpoint($device: desktop-md) {
    width: 100%;
  }
}
.articles-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 25px;

  .article {
    width: 100%;
    margin-bottom: 1rem;
    figure {
      border-radius: 10px 10px 0 0;
      margin: 0;
      width: 100%;
      height: 170px;
      background-size: cover;
      background-position: center;
      @include breakpoint($device: desktop-md) {
        height: 193px;
      }
      @include breakpoint($device: desktop-sm) {
        height: 145px;
      }
    }
    p {
      text-align: center;
      padding: 45px 15px;
      height: 121px;
      margin-bottom: 0px;
      background-color: $gray4;
      border-radius: 0 0 10px 10px;
    }
    transition: all 0.25s ease;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px #00000066;
    }
  }

  @include breakpoint($device: mobile) {
    grid-template-columns: 1fr;
  }
  @include breakpoint($device: tablet) {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
